'use strict';

var FlightFlowMixGraphFilterFactory = function FlightFlowMixGraphFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['FlightLevelFilterFactory', 'FlightCabinFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function FlightFlowMixGraphFilter() {
    DemandFilter.call(this, 'cabin-deep', 'market-mix-graph');
    this.registerFilters(injectedFilters);
  }
  FlightFlowMixGraphFilter.prototype = Object.create(DemandFilter.prototype);
  return FlightFlowMixGraphFilter;
};
FlightFlowMixGraphFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = FlightFlowMixGraphFilterFactory;